import React from "react";
import AnimatedList from "./AnimatedList";

export const Months = (props) => {
  const {
    dateHelper,
    months,
    setMonths,
    setSelectedDate,
    selectedDate,
    setActiveDate,
    activeDate,
    itemType,
    scrollToLocation,
    setScrollToLocation,
    scrollOffset,
    setScrollOffset,
    direction,
    cnObj,
  } = props;
  const LOADING = 1;
  const LOADED = 2;

  let itemStatusMap = {};

  function isItemLoaded(index) {
    return !!itemStatusMap[index];
  }
  const loadMoreItems = (startIndex, stopIndex) => {
    for (let index = startIndex; index <= stopIndex; index++) {
      itemStatusMap[index] = LOADING;
    }
    if (loadCondition({ startIndex, stopIndex })) {
      // method generates months from the beginning. Could be made more efficient
      setMonths(
        dateHelper.generateMonthsThrough({
          endYear:
            months[months.length - 1].year + Math.floor(months.length / 12),
        })
      );
      for (let index = startIndex; index <= stopIndex; index++) {
        itemStatusMap[index] = LOADED;
      }
    }
  };

  function loadCondition({ startIndex, stopIndex }) {
    switch (direction) {
      case "forward":
        return stopIndex >= months.length - 4;
      case "reverse":
        return false;
    }
  }

  function getItemSize(index) {
    const header = index === 0 ? 0 : 23;
    const gutter = index === months.length - 1 ? 8 : 0;
    const size = 3 + header + months[index].numWeeks * 37 + gutter;
    return size;
  }

  return (
    <AnimatedList
      {...AnimatedList.defaultProps}
      isItemLoaded={isItemLoaded}
      loadMoreItems={loadMoreItems}
      className="List"
      itemCount={months.length}
      itemSize={getItemSize}
      scrollToLocation={scrollToLocation}
      setScrollToLocation={setScrollToLocation}
      scrollOffset={scrollOffset}
      setScrollOffset={setScrollOffset}
      itemData={{
        months: months,
        dateHelper: dateHelper,
        selectedDate: selectedDate,
        setSelectedDate: setSelectedDate,
        activeDate: activeDate,
        setActiveDate: setActiveDate,
        calnoteObj: cnObj,
        itemType: itemType,
      }}
    ></AnimatedList>
  );
};

export default Months;
